import type { ReactNode } from "react"
import React from "react"
import {
    componentStyles,
    HorizontalStackSpaceBetween,
    TextBold,
    TextSmall,
    VerticalStack,
} from "@mallardbay/lib-react-components"

export enum GroupPayOptionValues {
    No = "no",
    Yes = "yes",
}

interface GroupPaySelectOptionType {
    value: GroupPayOptionValues
    label: string
    icon: ReactNode
    description: string
}

interface Props {
    readonly option: GroupPaySelectOptionType
}

export default function GroupPaySelectOption({ option }: Props) {
    const styles = useStyles()

    return (
        <VerticalStack style={styles.root}>
            <HorizontalStackSpaceBetween>
                <TextBold>{option.label}</TextBold>
                {option.icon}
            </HorizontalStackSpaceBetween>
            <TextSmall>{option.description}</TextSmall>
        </VerticalStack>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            alignItems: "stretch",
            gap: 2,
        },
    })
}
